import {
	get,
	axiosErrorHandler,
	post,
} from 'models/shared/helpers/axiosInstance';
import {
	GpsCommandResponse,
	HotspotsResponse,
	LocationResponse,
	SendGpsCommandDto,
	SingleLocationResponse,
} from '../interfaces/gps.interface';

const baseGpsPath = '/v1/gps';

export const FetchVehiclesLocations = async (): Promise<LocationResponse> => {
	try {
		const res = await get<LocationResponse>(baseGpsPath);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const getLocationByInternalId = async (
	internalId: string,
): Promise<SingleLocationResponse> => {
	try {
		const res = await get<SingleLocationResponse>(
			`${baseGpsPath}/${internalId}/location`,
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const getHotspotsByInternalId = async (
	internalId = '',
): Promise<HotspotsResponse> => {
	try {
		const res = await get<HotspotsResponse>(
			`${baseGpsPath}/${internalId}/hotspots`,
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const sendGpsCommand = async (
	imei: string,
	dto: SendGpsCommandDto,
): Promise<GpsCommandResponse> => {
	try {
		const res = await post<GpsCommandResponse>(
			`${baseGpsPath}/${imei}/commands`,
			dto,
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
